import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

// import {
//   Badge,
//   Popover,
//   PopoverBody,
//   Button,
//   Alert,
// } from 'reactstrap';

import BaseGrid from '../Common/BaseGrid';

function LocationSelector(props) {
  const {
    onSelect,
  } = props;

  const selectLocation = (location) => {
    onSelect(location);
  };

  const jsx = (
    <BaseGrid
      url="/api/warehouse/location"
      hasSearch
      config={
      {
        columns: {
          id: { label: 'ID', sort: true },
          zone: { label: 'Zone', sort: true },
          label: { label: 'Label', sort: true },
          type: { label: 'Type', sort: true },
          actions: {
            label: 'Actions',
            actions: [
              {
                key: 'select_location',
                icon: 'mdi mdi-check-bold',
                class: 'btn btn-sm btn-soft-info text-dark',
                alt: 'Select',
                click: selectLocation,
              },
            ],
          },
        },
        pagination: {
          sort: 'id',
          direction: 'asc',
          perPage: 10,
        },
      }
      }
    />
  );

  return jsx;
}

LocationSelector.defaultProps = {
  t: () => {},
  onSelect: () => {},
};

LocationSelector.propTypes = {
  // eslint-disable-next-line react/no-unused-prop-types
  t: PropTypes.any,
  onSelect: PropTypes.func,
};

export default connect(() => ({

}), {})(withTranslation()(LocationSelector));
